import React from 'react';
import { Link } from 'gatsby';
import { Edge } from '../../types/index';
import * as styles from './FeedItem.module.scss';

type Props = {
   edge: Edge;
};

const FeedItem = ({ edge }: Props) => (
   <div className={styles['feeditem']} key={edge.node.fields.slug}>
      <div className={styles['feeditem_meta']}>
         <time
            className={styles['feeditem_meta_time']}
            dateTime={new Date(edge.node.frontmatter.date).toLocaleDateString('en-US', {
               year: 'numeric',
               month: 'long',
               day: 'numeric'
            })}
         >
            {new Date(edge.node.frontmatter.date).toLocaleDateString('en-US', {
               year: 'numeric',
               month: 'long'
            })}
         </time>
         <span className={styles['feeditem_meta_divider']} />
         <span className={styles['feeditem_meta_category']}>
            <Link
               to={edge.node.fields.categorySlug}
               className={styles['feeditem_meta_category_link']}
            >
               {edge.node.frontmatter.category}
            </Link>
         </span>
      </div>
      <h2 className={styles['feeditem_title']}>
         <Link className={styles['feeditem_title_link']} to={edge.node.fields.slug}>
            {edge.node.frontmatter.title}
         </Link>
      </h2>
      <p className={styles['feeditem_description']}>{edge.node.frontmatter.description}</p>
      <Link className={styles['feeditem_readmore']} to={edge.node.fields.slug}>
         Read
      </Link>
   </div>
);

export default FeedItem;
